webpackJsonp([1],{

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(20);

var _components = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO -- Add Outline to get to content quickly
exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
  var values = _ref.values,
      processBlurb = _ref.processBlurb,
      story = _ref.story,
      hireMeTo = _ref.hireMeTo,
      goodFit = _ref.goodFit,
      badFit = _ref.badFit,
      haveAProject = _ref.haveAProject;
  return _react2.default.createElement(
    _components.Container,
    { maxWidth: 'medium', mb: 5 },
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement(
        'title',
        null,
        'Will Hoag - Work Together'
      ),
      _react2.default.createElement('meta', { name: 'description', content: 'Details about what it would be like to work together on a project' })
    ),
    _react2.default.createElement(_components.BlurbSection, { mt: 5, blurb: haveAProject }),
    _react2.default.createElement(_components.BlurbSection, { mt: 5, blurb: hireMeTo }),
    _react2.default.createElement(_components.BlurbSection, { mt: 5, blurb: story }),
    _react2.default.createElement(_components.BlurbSection, { mt: 5, blurb: values }),
    _react2.default.createElement(_components.BlurbSection, { mt: 5, blurb: processBlurb }),
    _react2.default.createElement(_components.BlurbSection, { mt: 5, blurb: goodFit }),
    _react2.default.createElement(_components.BlurbSection, { mt: 5, mb: 5, blurb: badFit })
  );
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Working.789cd829.js